import * as ko from "knockout";
import { ContractYearList } from "../Models/Pdf/ContractYearList";
import { groupBy, map, orderBy, forEach, isEmpty } from "lodash-es";
import "footable-npm";
import { PdfInfo } from "../Models/Pdf/PdfInfo";
import { SettingsApi } from "../Apis/SettingsApi";

export class ContractViewModel {
    //Custom filter function to apply url filters.
    customfilterFunction: (item: any) => boolean;

    //List of active custom filters.
    customFilters = ko.observableArray<string>();

    //Url query for the custom filter.
    customFilterQuery = ko.observable<string>();

    //Full lists of the contracts for the grower, this should ONLY be updated through ajax.
    completelist = ko.observableArray<PdfInfo>();

    //Show spinner or not.
    loading = ko.observable<boolean>(true);

    private expirationDate:Date;

    //Active filters collection
    private contractFilters = ko.observableArray<string>();

    private signedContractFilter = ko.observableArray<string>();

    private filterQueryPrefix: string = "contractType";

    isNew(date: Date): boolean {
        return date > this.expirationDate;
    }

    /*
     * Subset of completelist with applied filter.
     */
    private filteredList: KnockoutComputed<PdfInfo[]> = ko.computed(() => {
        return ko.utils.arrayFilter(this.completelist(), (item: PdfInfo) => {
            return (this.contractFilters().indexOf(item.Status) > -1 || this.contractFilters().length === 0) &&
            (this.signedContractFilter().indexOf(item.Signed ? "Yes" : "No") > -1 ||
                this.signedContractFilter().length === 0);
        });
    });

    private contractStatusTypes: KnockoutComputed<string[]> = ko.computed(() => {
        return Array.from(new Set(this.completelist().map((item: PdfInfo) => item.Status))).reverse();
    });

    private contractSignedTypes: KnockoutComputed<string[]> = ko.computed(() => {
        return Array.from(new Set(this.completelist().map((item: PdfInfo) => item.Signed ? "Yes" : "No"))).reverse();
    });

    /*
     * Collection used for the graphic table representations.
     */
    private groupedByYear: KnockoutComputed<ContractYearList[]> = ko.computed(() => {

        let list = new Array<ContractYearList>();
        var groupedList = groupBy(orderBy(this.filteredList(), c => c.SowingYear), (item) => item.SowingYear);
        forEach(groupedList, e => {
            const year = e[0].SowingYear;
            list.push(new ContractYearList(year, e));
        });

        return orderBy(list, c => c.Year, 'desc');
    });


    constructor() {

        SettingsApi.getInstance().getExpirationDate().then((res) => this.expirationDate = res);
        //Subscribe to subset of crops change to keep footable up to date.
        this.filteredList.subscribe(() => {
            ($('.toBeFoo') as any).footable();
        });

        let initialFilter = new Array<string>("Aktiv");

        this.contractStatusTypes.subscribe(() => {
            this.contractFilters(initialFilter);
        });

        //TODO: Implement if URL Parameters are needed
        //this.contractStatusTypes.subscribe((value: string[]) => {
        //    const url = new URL(window.location.href);
        //    console.log(url);
        //    const filterQuery = url.searchParams.get(this.filterQueryPrefix);
        //    if (!isEmpty(filterQuery)) {
        //        const filter = filterQuery.split(',');
        //        this.contractFilters(filter);
        //    }
        //});

        //this.contractFilters.subscribe((value: string[]) => {
        //    const url = new URL(window.location.href);
        //    if (value.length > 0) {
        //        url.searchParams.set(this.filterQueryPrefix, value.join(","));
        //    } else {
        //        url.searchParams.delete(this.filterQueryPrefix);
        //    }

        //    //Replace url encoded commas: %2C with accutual commas as its prettier.
        //    const uriWithoutCommas = url.toString().split('%2C').join(",");
        //    history.pushState(null, '', uriWithoutCommas);
        //});
    }

    /**
     * Removes/disables an active filter from the filter collection 'contractFilters'.
     * @param filter
     */
    removeFilter(filter: any, filterCollection: KnockoutObservableArray<string>): void {
        filterCollection.remove(filter);
       }

    removeAllFilters(): void {
        this.contractFilters.removeAll();
        this.signedContractFilter.removeAll();
    }

    removeFilterCustomFilter(filter: string): void {
        this.customFilters.remove(filter);

        const url = new URL(window.location.href);
        url.searchParams.delete(this.customFilterQuery());
        //Replace url encoded commas: %2C with accutual commas as its prettier.
        const uriWithoutCommas = url.toString().split('%2C').join(",");
        history.pushState(null, '', uriWithoutCommas);

    }

    /**
     * Multiplies the input number with the given factor
     * @param input
     * @param factor
     */
    multiply(input: number, factor: number): number {
        return input * factor;
    }

    /**
     * Multiplies number and returns it as a string based on the locale and digits.
     * Returns default value if input was null.
     * @param input To be muliplied with the factor
     * @param factor Factor to multiply input with
     * @param digits Number of digigts on the return value (requires locale)
     * @param locale Locale string to return.
     * @param defaultValue Default value if input was null.
     */
    multiplyAndRoundToLocale(input: number, factor: number, digits: number, locale: string, defaultValue: string): string {
        if (input == null)
            return defaultValue;

        const result = input * factor;
        if (!isEmpty(locale)) {

            return digits != null
                ? result.toLocaleString(locale, { maximumFractionDigits: digits })
                : result.toLocaleString(locale);
        }

        return result.toString();


    }
}